import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxCurrencyModule } from "ngx-currency";
export const customCurrencyMaskConfig = {
  align: "right",
  allowNegative: true,
  allowZero: true,
  decimal: ".",
  precision: 0,
  prefix: "$ ",
  suffix: "",
  thousands: ",",
  nullable: true
};
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ChartsModule } from 'ng2-charts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule,HTTP_INTERCEPTORS  } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule, NgbDatepickerModule, NgbDatepicker, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './shared/components/menu/menu.component';
import { HomeComponent } from './modules/home/home.component';
import { CounterComponent } from './modules/counter/counter.component';
import { FetchDataComponent } from './modules/fetch-data/fetch-data.component';
import { LoginComponent } from './modules/login/login.component';
import { FirstTimeComponent } from './modules/login/first-time/first-time.component';
import { ChangePasswordComponent } from './modules/login/change-password/change-password.component';
import { AdminUsersComponent, AdminUserResolve } from './modules/admin-users/admin-users.component';
import { DividerComponent } from './shared/components/divider/divider.component';
import { DetailUserComponent } from './modules/admin-users/detail-user/detail-user.component';
import { NewUserComponent } from './modules/admin-users/new-user/new-user.component';
import { UserFilterPipe } from './shared/pipes/user-filter.pipe';
import { EstadosFilterPipe } from './shared/pipes/estado-filter.pipe';
import { AlertComponent } from './shared/components/alert/alert.component';
import { appRoutes } from './routes';
import { ErrorInterceptor } from './shared/_helpers/error.interceptor';
import { JwtInterceptor } from './shared/_helpers/jwt.interceptor';
import { LoaderInterceptor } from './shared/_helpers/loader.interceptor';
import { LostPasswordComponent } from './modules/login/lost-password/lost-password.component';
import { JoinAppComponent } from './modules/login/join-app/join-app.component';
import { SummaryUserComponent } from './modules/admin-users/summary-user/summary-user.component';
import { ManageFileComponent } from './modules/manage-file/manage-file.component';
import { LoadFileComponent } from './modules/manage-file/load-file/load-file.component';
import { FillAgentsComponent } from './modules/manage-file/fill-agents/fill-agents.component';
import { FillBranchComponent } from './modules/manage-file/fill-branch/fill-branch.component';
import { FillOfficesComponent } from './modules/manage-file/fill-offices/fill-offices.component';
import { FillCitiesComponent } from './modules/manage-file/fill-cities/fill-cities.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { DownloadFeedbackComponent } from './modules/manage-file/download-feedback/download-feedback.component';
import { FileReportComponent } from './modules/manage-file/file-report/file-report.component';
import { FooterComponent } from './modules/manage-file/footer/footer.component';
import { PortfolioComponent } from './modules/portfolio/portfolio.component';
import { SummaryPortfolioComponent } from './modules/portfolio/summary-portfolio/summary-portfolio.component';
import { DetailPortfolioComponent } from './modules/portfolio/detail-portfolio/detail-portfolio.component';
import { GenerateLetterComponent } from './modules/generate-letter/generate-letter.component';
import { PolicyDetailComponent } from './modules/portfolio/policy-detail/policy-detail.component';
import { ManagementResultFilterPipe } from './shared/pipes/managementresult-filter.pipe';
import { PortfolioStateFilterPipe } from './shared/pipes/portfoliostate-filter.pipe';
import { PolicyFilterPipe } from './shared/pipes/policy-filter.pipe';
import { SecondPolicyFilterPipe } from './shared/pipes/secondpolicy-filter.pipe';
import { DebtorNameFilterPipe } from './shared/pipes/debtorname-filter.pipe';
import { ManagementComponent } from './modules/management/management.component';
import { AdminTablesComponent } from './modules/admin-tables/admin-tables.component';
import { TableAgentsComponent } from './modules/admin-tables/table-agents/table-agents.component';
import { TableCitiesComponent } from './modules/admin-tables/table-cities/table-cities.component';
import { TableOfficesComponent } from './modules/admin-tables/table-offices/table-offices.component';
import { TableBranchesComponent } from './modules/admin-tables/table-branches/table-branches.component';
import { TableCompanyComponent } from './modules/admin-tables/table-company/table-company.component';
import { TablesFilterPipe } from './shared/pipes/tables-filter.pipe';
import { PaymentsCancellationsComponent } from './modules/payments-cancellations/payments-cancellations.component';
import { DevolutionsComponent } from './modules/devolutions/devolutions.component';
import { SearchComponent } from './modules/search/search.component';
import { ReportsComponent } from './modules/reports/reports.component';
import { DebtorDetailComponent } from './modules/portfolio/debtor-detail/debtor-detail.component';
import { HomeAssistantComponent } from './modules/home/home-assistant/home-assistant.component';
import { HomeGeneralComponent } from './modules/home/home-general/home-general.component';
import { UserRoleFilterPipe } from './shared/pipes/user-role-filter.pipe';
import { UserOfficeFilterPipe } from './shared/pipes/user-office-filter.pipe';


@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    LoginComponent,
    FirstTimeComponent,
    ChangePasswordComponent,
    AdminUsersComponent,
    DividerComponent,
    DetailUserComponent,
    UserFilterPipe,
    EstadosFilterPipe,
    AlertComponent,
    NewUserComponent,
    LostPasswordComponent,
    JoinAppComponent,
    SummaryUserComponent,
    LoadFileComponent,
    ManageFileComponent,
    FillAgentsComponent,
    FillBranchComponent,
    FillOfficesComponent,
    FillCitiesComponent,
    LoaderComponent,
    DownloadFeedbackComponent,
    FileReportComponent,
    FooterComponent,
    PortfolioComponent,
    SummaryPortfolioComponent,
    DetailPortfolioComponent,   
    GenerateLetterComponent,   
    PolicyDetailComponent,
    ManagementResultFilterPipe,
    PortfolioStateFilterPipe,
    PolicyFilterPipe,
    SecondPolicyFilterPipe,
    DebtorNameFilterPipe,
    ManagementComponent,
    AdminTablesComponent,
    TableAgentsComponent,
    TableCitiesComponent,
    TableOfficesComponent,
    TableBranchesComponent,
    TableCompanyComponent,
    TablesFilterPipe,
    PaymentsCancellationsComponent,
    DevolutionsComponent,
    SearchComponent,
    ReportsComponent,
    DebtorDetailComponent,
    HomeAssistantComponent,
    HomeGeneralComponent,
    UserRoleFilterPipe,
    UserOfficeFilterPipe
  ],
  imports: [
    NgMultiSelectDropDownModule.forRoot(),
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot(appRoutes),
    BrowserAnimationsModule,
    NgbModule.forRoot(),
    ReactiveFormsModule,
    NgxPaginationModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    ChartsModule
    //NgbDatepickerModule,
   
  ],
  entryComponents:[AlertComponent],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    AdminUserResolve
  ],
  bootstrap: [AppComponent] 
})
export class AppModule { }
